module.exports = __webpack_public_path__ + "static/media/SaladAppleBlueberry.d4e2757a.jpg";